export default __webpack_public_path__ + "static/ceiling-collapse-883a2664782ed5eac2fca85a3fcab4e4.jpg";